import { render, staticRenderFns } from "./resumePdf.vue?vue&type=template&id=faca4eac"
import script from "./resumePdf.vue?vue&type=script&lang=js"
export * from "./resumePdf.vue?vue&type=script&lang=js"
import style0 from "./resumePdf.vue?vue&type=style&index=0&id=faca4eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports